module.exports = __webpack_public_path__ + "img/paofulaoshi.51632115.png";